import React, { Component } from "react";
import { Button, Collapse, Alert } from "reactstrap";
import { connect } from "react-redux";
import moment from "moment";
import size from "lodash/size";
import get from "lodash/get";
import axios from "../../axios";
import * as actionCreators from "./../../modules/actions/index";
import TabBar from "../../components/TabBar/TabBar";
import Search from "../../components/Search/Search";
import DateFilter from "../../components/DateFilter/DateFilter";
import ChartMetricesFilter from "./Metrics/ChartsMetrics";
import StoriesGrid from "./DataGrid/StoriesGrid";
// import DataChartUI from './DataChart/StoriesChart';
import DataChartUI from "./DataChart/Chart";

import Loading from "../../hoc/Loading/Loading";
import * as url from "../../utils/url";
import ExportToCSV from "./ExportToCsv/ExportToCsvStories";
import { objectEncode } from "../../components/Shared/ReusablesUtils";
import PropTypes from "prop-types";
import "./Analytics.css";
import NoDataFound from "../../assets/no-kpidata-range.png";

const searchByUserNamePlaceholder = "Search stories...";
const Filters = "Filters";
const chartXAxesMessage =
  "Data on the chart represents weekly aggregates, starting every Monday.";
// Temporary URL for API CALL which needs to be changed when application hosted to DEV server.
// const URL = 'http://10.0.2.155:8090/charts/v1/chart-metrics/';
class StoriesAnalytics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "1",
      isFilterCollapsed: false,
      searchObject: {
        metrics: [],
        // startDate: moment().subtract(1, 'month').toISOString(),
        startDate:
          this.props && this.props.user && this.props.user.organizationId
            ? moment(this.props.user.organizationId.createdDate).toISOString()
            : moment().subtract(1, "month").toISOString(),
        endDate: moment().toISOString(),
        storyTitle: "",
      },
    };
  }

  componentDidMount() {
    // Fetch Chart Analytics Data
    this.fetchLatestData();
    // Fetching Users Tab Metrices
    this.props.onFetchstoriesMetrices();
  }

  modifyDateTimestamp = (momentDate, date) => {
    let dateSplit = momentDate.split("T");
    return `${dateSplit[0]}${
      date === "startDate" ? "T00:00:00Z" : "T23:59:59Z"
    }`;
  };

  fetchLatestData = () => {
    // Fetch latest data with combination for filters
    const {
      searchObject: { metrics, startDate, endDate, storyTitle },
    } = this.state;
    const {
      user: { organizationId },
    } = this.props;
    const getFilterObject = {
      metrics: metrics.toString(),
      startDate: this.modifyDateTimestamp(startDate, "startDate"),
      endDate: this.modifyDateTimestamp(endDate, "endDate"),
      storyTitle: encodeURIComponent(storyTitle),
      organizationId: encodeURIComponent(organizationId._id),
    };
    axios
      .get(`${url.getStoriesAnalytics}${objectEncode(getFilterObject)}`)
      .then(({ data }) => {
        this.props.onFetchstoriesAnalyticsSuccess(data.data.data);
      });
  };

  toggleCollapse = () => {
    const { isFilterCollapsed } = this.state;
    this.setState({
      isFilterCollapsed: !isFilterCollapsed,
    });
  };

  handleSearch = e => {
    const { value } = e.target;
    this.setState(
      {
        searchObject: {
          ...this.state.searchObject,
          storyTitle: value,
        },
      },
      () => {
        this.fetchLatestData();
      }
    );
  };

  handleMetricsFilter = (metricId, event) => {
    const { checked } = event.target;
    let { metrics } = this.state.searchObject;

    if (checked && metrics !== undefined) {
      metrics.push(metricId);
    } else {
      metrics.splice(metrics.indexOf(metricId), 1);
    }
    this.setState(
      {
        searchObject: {
          ...this.state.searchObject,
          metrics,
        },
      },
      () => {
        this.fetchLatestData();
      }
    );
  };

  handlePagination = e => {
    const { value } = e.target;
    this.setState(
      {
        searchObject: {
          ...this.state.searchObject,
          page: value,
        },
      },
      () => {
        this.fetchLatestData();
      }
    );
  };

  handleStartDateChange = date => {
    this.setState(
      {
        searchObject: {
          ...this.state.searchObject,
          startDate: date,
        },
      },
      () => {
        const {
          searchObject: { endDate },
        } = this.state;
        if (endDate !== "") {
          this.fetchLatestData();
        }
      }
    );
  };

  handleEndDateChange = date => {
    this.setState(
      {
        searchObject: {
          ...this.state.searchObject,
          endDate: date,
        },
      },
      () => {
        const {
          searchObject: { startDate },
        } = this.state;
        if (startDate !== "") {
          this.fetchLatestData();
        }
      }
    );
  };

  render() {
    const { isFilterCollapsed, searchObject } = this.state;
    const { storiesAnalytics, storiesMetrices, history } = this.props;
    let { orgAdmin } = this.props.user;
    console.log("stories---", storiesAnalytics);
    return (
      <div className="mt70 analytics-form">
        <div className="row ml-0 mr-0 mb-3 text-size">
          <div className="title-text">Metrics</div>
          {orgAdmin ? (
            <TabBar
              activeTab={"6"}
              history={history}
              isOrgSetup={this.props.user.organizationId.isSetupSkipped}
            />
          ) : null}
        </div>
        <div className="row p-0 m-0 height40">
          <Search
            placeholder={searchByUserNamePlaceholder}
            handleSearch={this.handleSearch}
            value={searchObject.storyTitle}
          />
          <div className="col-lg-2 filter-select col-md-3 col-sm-3 pl0 pr0"></div>
        </div>
        {/* <DateFilter
          handleStartDateChange={this.handleStartDateChange}
          handleEndDateChange={this.handleEndDateChange}
          searchObject={searchObject}
        /> */}
        <div className="row p-0 m-0"></div>
        <div>
          <div className="dataChartStyle">
            <div className="dataChartDisplay">
              <DataChartUI
                chartValue="Stories"
                chartAnalytics={storiesAnalytics}
                chartMetrices={storiesMetrices}
                searchObject={searchObject}
              />
              <Alert className="btmMargin0" color="light">
                {chartXAxesMessage}
              </Alert>
              <p className="chartUseMsg">
                To zoom in, click and drag across the chart area. To zoom out,
                triple click on the chart area.
              </p>
            </div>
          </div>
          {storiesAnalytics.length > 0 && (
            <div className="row">
              <ExportToCSV
                Analytics={get(this.props, "storiesAnalytics", [])}
                chartMetrices={storiesMetrices}
              />
            </div>
          )}
        </div>
        <div>
          <StoriesGrid
            user={this.props.user}
            storiesAnalytics={storiesAnalytics}
            storiesMetrices={storiesMetrices}
            searchObject={searchObject}
            onFetchstoriesAnalyticsSuccess={
              this.props.onFetchstoriesAnalyticsSuccess
            }
          />
        </div>
      </div>
    );
  }
}

StoriesAnalytics.propTypes = {
  isFilterCollapsed: PropTypes.bool,
  searchObject: PropTypes.object,
  storiesAnalytics: PropTypes.array,
  storiesMetrices: PropTypes.array,
  history: PropTypes.object,
  onFetchstoriesAnalyticsSuccess: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  return {
    storiesAnalytics: state.dashboard.StoriesAnalytics,
    storiesMetrices: state.dashboard.StoriesMetrics,
    user: state.user.profile,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    onFetchstoriesAnalyticsSuccess: data =>
      dispatch(actionCreators.fetchStoriesAnalyticsSuccess(data)),
    onFetchstoriesMetrices: () =>
      dispatch(actionCreators.fetchStoriesMetrices()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Loading(StoriesAnalytics, axios));
